module.exports = __webpack_public_path__ + "img/man.044437d3.svg";